import { TextField } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { alert } from "src/services/alert";
import FormDialog from "../common/FormDialog";
import FormItem from "../form-item/FormItem";

const ChangeInfoDialog = ({ open, onClose }) => {

  // const {} = 

  const [form, setForm] = useState({
    realname: "",
    mobile: "",
  });

  function handleIptChange(ki, val) {
    // console.log(ki, val);
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function handleDialogConfirm() {
    axios
      .post("/system/admin/changeInfo", {
        ...form,
      })
      .then((res) => {
        const { code, msg, data } = res.data;
        if (code === 1) {
          setForm({
            mobile: "",
            realname: "",
          });
          alert(msg, "success");
          onClose();
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("update personal info err: ", err);
      });
  }

  return (
    <FormDialog title="修改密码" open={open} onClose={onClose} onConfirm={handleDialogConfirm}>
      <FormItem title="姓名">
        <TextField fullWidth placeholder="姓名" id="realname" value={form.realname} size="small" onChange={(e) => handleIptChange("realname", e.target.value)} />
      </FormItem>

      <FormItem title="号码">
        <TextField fullWidth placeholder="号码" autoComplete="off" id="mobile" value={form.mobile} size="small" onChange={(e) => handleIptChange("mobile", e.target.value)} />
      </FormItem>
    </FormDialog>
  );
};

export default ChangeInfoDialog;
